import { useEffect, useState } from "react";
import { Phone, ArrowRight } from "lucide-react";

export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 pb-16 sm:pb-20 px-3 transition-all duration-400 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      aria-hidden={!visible}
    >
      <div className="bg-stone-900/95 backdrop-blur-xl rounded-2xl shadow-[0_20px_50px_-15px_rgba(28,25,23,0.5)] grid grid-cols-2 gap-px overflow-hidden">
        <a
          href="tel:+16368496681"
          data-testid="mobile-sticky-call"
          className="flex items-center justify-center gap-2 py-3.5 text-stone-50 text-sm font-semibold hover:bg-stone-800 transition-colors"
        >
          <Phone size={15} strokeWidth={2.25} className="text-orange-400" />
          Call us
        </a>
        <a
          href="#contact"
          data-testid="mobile-sticky-quote"
          className="flex items-center justify-center gap-1.5 py-3.5 bg-orange-500 text-stone-50 text-sm font-semibold hover:bg-orange-600 transition-colors"
        >
          Free Quote
          <ArrowRight size={15} strokeWidth={2.25} />
        </a>
      </div>
    </div>
  );
}
